import React from "react";


import { connect } from "react-redux";

class AccountLedgerSubTxnModal extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }

  
    render(){
    console.log('Inside render');
    return(
                    <div class="subtxnshow">
									
                                    <div class="csmrdtl">
                                        <div class="row">
                                            <div class="col-12 col-md">
                                                <div class="txntsubdtl">
                                                    <p>Consumer Name</p>
                                                    <h5>Rajesh Gupta</h5>
                                                </div>
                                            </div>
                                            
                                            <div class="col-12 col-md">
                                                <div class="txntsubdtl">
                                                    <p>Mobile no.</p>
                                                    <h5>+91-9898989898</h5>
                                                </div>
                                            </div>
                                            
                                            <div class="col-12 col-md">
                                                <div class="txntsubdtl">
                                                    <p>State</p>
                                                    <h5>Haryana</h5>
                                                </div>
                                            </div>
                                            
                                            <div class="col-6 col-md">
                                                <div class="txntsubdtl">
                                                    <p>Bill Date</p>
                                                    <h5>10-11-2021</h5>
                                                </div>
                                            </div>
                                            
                                            <div class="col-6 col-md">
                                                <div class="txntsubdtl">
                                                    <p>Bill Due Date</p>
                                                    <h5>15-11-2021</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                    <div class="txn-btn">										
                                        <button type="button" class="print" data-bs-toggle="modal" 
                                        data-bs-target="#print" onClick={this.print}>Print</button>
                                        <button type="button" class="share" onClick={this.share}>Share</button>
                                        <button type="button" class="help" onClick={this.help}>Support</button>
                                    </div>
                                </div>
									
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(AccountLedgerSubTxnModal);
